export default "__VITE_ASSET__BvtoMC$H__"